'use strict';

Odigeo.defineWidget('offline_sales_banner', Odigeo.Widget.extend({
    viewClass: Odigeo.View.extend({
        slctrs: {
            template: '.offline-sales-banner-template',
            wrapper: '.offline-sales-banner-wrapper',
        },
        init: function() {
            this.opts = Odigeo.Utils.parseOptions(this.widget.options);
            this.bindEvents();
            this.update();
        },
        bindEvents: function() {
            Odigeo.bind('routeChange', _.bind(this.update, this));
        },
        update: function() {
            this.renderize('');
            this.setTemplate();
        },
        renderize: function(content) {
            this.$el.find(this.slctrs.wrapper).html(content);
        },
        setTemplate: function() {
            var pageNameFromFragment = Odigeo.History.getPageNameFromFragment();
            var currentPage = _.isEmpty(pageNameFromFragment) ? 'home' : pageNameFromFragment;
            var template = _.template(this.$el.find(this.slctrs.template).html(), Odigeo.Utils.getTmplSettings());

            if (currentPage === this.opts.tmpl &&
                'true' === this.opts.translations.active) {
                this.renderize(template({
                    title: this.opts.translations.title,
                    charge: this.opts.translations.charge,
                    hours: this.opts.translations.hours,
                    phone: this.opts.translations.phone,
                }));
            }
        },
    }),
}));
